 import React from "react";

const Footer = (props) => {
  let d = new Date();
  return (
    <div className={`footer ${props.changeFooter} mb-3 `}>
      <div className="copyright">
        <p>
          Copyright © Designed &amp; Developed by{" "}
          <a href="https://technologyxtend.com/" target="_blank" rel="noreferrer">
            Technology Xtend 
          </a>{" "}
          {d.getFullYear()}
        </p>
      </div>
    </div>
  );
};

export default Footer;
